import React, { Component } from 'react';
import Top10HomeContainer from '../../components/top10/containers/Top10HomeContainer';
// import Poll from '../../components/poll';
// import ArtistsSlider from '../../components/artists/containers/ArtistsSliderContainer';
// import VideosSlider from '../../components/videos/containers/VideosSliderContainer';
// import AlbumsSlider from '../../components/artists/containers/AlbumsSliderContainer';
import HeaderTags from '../../common/headerTags/HeaderTags';
import { getNewsHomeDataIfNeeded, getNewsDataIfNeeded } from '../../components/news/actions/NewsActions';
import { getTop10DataIfNeeded } from '../../components/top10/actions/Top10Actions';
import NewsHome from '../../components/news/containers/NewsHomeContainer';
// import Banner from '../../common/Banner/Banner';
// import PodcastsBanner from '../../common/podcastsBanner/PodcastsBanner';
// import SupportingText from '../../common/supportingText/SupportingText';
// import PromotionsSlider from '../../components/promotions/containers/PromotionsSliderContainer';
// import DaysSentence from '../../components/daysSentence/containers/DaysSentenceContainer';
import NewsBlock from '../../components/news/containers/NewsBlockContainer';
import NewsHomeMostReadContainer from '../../components/news/containers/NewsHomeMostReadContainer';

const jsonld =
{
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: 'Antena 1',
    url: 'https://www.antena1.com.br/',
    logo: 'https://www.antena1.com.br/Logo-default.png', // @TODO use the logo from the appReducer?
    sameAs: [
        'https://www.facebook.com/Antena1.BR',
        'https://twitter.com/Antena_1',
        'https://www.instagram.com/antena1/',
        'https://www.youtube.com/Antena1Brasil',
    ],
    contactPoint: [{
        '@type': 'ContactPoint',
        telephone: '+55-11-3034-2224',
        contactType: 'customer service',
        areaServed: 'BR',
    }],
};
const headerTags =
{
    title: 'A rádio online mais ouvida do Brasil', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta:
    {
        description: 'Quer ficar por dentro do que acontece no mundo da música e ouvir música internacional de qualidade? Sintonize na Antena 1 online.',
        keywords: 'rádio, online, antena1, a1, antena 1, ao vivo, aovivo, play, player, música de filme, home, inicio, artistas, fm, frequência, notícias, promoções, programação musical, podcast, música, enquete, vídeos, álbuns, capas, anos 60, anos 80, anos 90, anos 2000, sucessos, música internacional, música romântica, música para relaxar, música para malhar, adele, bruno mars, charlie puth, ed sheeran, jennifer lopez, justin timberlake, lady gaga, maroon 5, the weeknd, abba',
        'og:title': 'Antena 1 - A rádio online mais ouvida do Brasil',
        'og:description': 'Quer ficar por dentro do que acontece no mundo da música e ouvir música internacional de qualidade? Sintonize na Antena 1 online.',
        'og:image': 'https://a1media.antena1.com.br/image/share/antena1.png',
    },
    script:
        [
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify(jsonld),
            },
        ],
};
// const supportingTextInfo = {
//     title: 'A Rádio Antena 1',
//     description: `Traz os grandes sucessos das paradas americanas e europeias com uma variedade incrível de artistas das décadas de 1960, 1970, 1980, 1990, 2000 e 2010.
//         Ouça artistas clássicos como The Beatles, Michael Jackson, Céline Dion, Duran Duran, A-ha, Tina Turner, Elton John, Phil Collins, Tears for Fears, David Bowie, Andrea Bocelli e U2.
//         Também fique sintonizado nos últimos lançamentos dos cantores(as) Beyoncé, Ed Sheeran, Bruno Mars, Katy Perry, Coldplay, Harry Styles, Adele, Justin Timberlake, Sia, P!nk, Lady Gaga, entre outros
//         Ouça a rádio pelos smartphones, por meio do site ou aplicativo disponível para as linhas iPhone, sistema iOS da Apple e para os celulares com Android.`,
//     buttonText: 'História completa',
//     buttonLink: '/quem-somos',
// };
// const firstBannerConfig = {
//     title: 'CONTINUE DEPOIS DA PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-home-first_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };
// const secondBannerConfig = {
//     title: 'CONTINUE DEPOIS DA PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-home-second_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };


// const thirdBannerConfig = {
//     title: 'CONTINUE DEPOIS DA PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-home-third_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };


// const fourthBannerConfig = {
//     title: 'CONTINUE DEPOIS DA PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-home-fourth_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };


// eslint-disable-next-line padding-line-between-statements
// const fifthBannerConfig = {
//     title: 'CONTINUE DEPOIS DA PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-home-fifth_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

/*
const sixthBannerConfig = {
    title: "CONTINUE DEPOIS DA PUBLICIDADE",
    class: "col-11",
    adUnit: "a1nova-home-sixth_multi_sizes",
    sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
    sizeMapping: [
        { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
        { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
        { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
        { viewport: [0, 0], sizes: [[250, 250], [234, 60]] }
    ],
    shouldRefresh: true
}
*/

// Defining it here so it can be passed to the fetchData function and won't be forgotten in the future if changed
// eslint-disable-next-line padding-line-between-statements
const newsBlockSettings = {
    category: 'tudo',
    numNews: 13,
    numNewsMobile: 6,
    title: 'Mundo',
    buttonText: 'Ver mais',
    skipFeatured: true,
};

class Home extends Component {
    static fetchData(store) {
        const myPromises = [
            store.dispatch(getNewsHomeDataIfNeeded()),
            store.dispatch(getNewsDataIfNeeded(newsBlockSettings.numNews, 0)), // fetching always the desktop number of news, as we do not know if the user is on mobile or desktop, while on the server
            store.dispatch(getTop10DataIfNeeded()),
        ];

        return Promise.all(myPromises);
    }

    render() {
        return (
            <div className="tw-flex tw-min-h-screen tw-flex-col tw-items-center tw-justify-between">
                <HeaderTags
                    title={headerTags.title}
                    meta={headerTags.meta}
                    script={headerTags.script}
                />
                <NewsHome />
                {/* <Banner
                    key={firstBannerConfig.adUnit}
                    config={firstBannerConfig}
                /> */}
                {/* <PodcastsBanner /> */}
                <NewsBlock
                    category={newsBlockSettings.category}
                    numNews={newsBlockSettings.numNews}
                    numNewsMobile={newsBlockSettings.numNewsMobile}
                    title={newsBlockSettings.title}
                    buttonText={newsBlockSettings.buttonText}
                    skipFeatured={newsBlockSettings.skipFeatured}
                />

                {/* <Banner
                    key={secondBannerConfig.adUnit}
                    config={secondBannerConfig}
                /> */}
                <NewsHomeMostReadContainer />
                {/* <Poll /> */}
                {/* <ArtistsSlider
                    withTitle
                /> */}
                {/* <Banner key={thirdBannerConfig.adUnit} config={thirdBannerConfig} /> */}

                <Top10HomeContainer />
                {/* <DaysSentence /> */}
                {/* <Banner key={fourthBannerConfig.adUnit} config={fourthBannerConfig} /> */}
                {/* <AlbumsSlider /> */}
                {/* <Banner
                    key={fifthBannerConfig.adUnit}
                    config={fifthBannerConfig}
                /> */}
                {/* <PromotionsSlider /> */}
                {/* <Banner key={sixthBannerConfig.adUnit} config={sixthBannerConfig} /> */}
                {/* <SupportingText
                    title={supportingTextInfo.title}
                    description={supportingTextInfo.description}
                    buttonText={supportingTextInfo.buttonText}
                    buttonLink={supportingTextInfo.buttonLink}
                /> */}
            </div>
        );
    }
}

export default Home;
